<template>
  <div class="kyc-prep">
    <template v-if="isKyc">
      <p class="has-text-weight-bold is-size-4">
        {{ $t("af:application.kyc_prep.title") }}
      </p>
      <p class="mb-6">
        {{ $t("af:application.kyc_prep.subtitle") }}
      </p>

      <application-template template="KYC_PREP"></application-template>
    </template>
    <template v-else>
      <p class="has-text-weight-bold is-size-4">
        {{ $t("af:application.sign_prep.title") }}
      </p>
      <p class="mb-6">
        {{ $t("af:application.sign_prep.subtitle") }}
      </p>

      <application-template template="SIGN_PREP"></application-template>
    </template>
  </div>
</template>

<script>
import { FLOW_POSITION } from "../../utils/const";

export default {
  name: "ApplicationFlowKYCPreparation",
  components: {
    ApplicationTemplate: () => import("@/components/ApplicationTemplate.vue"),
  },
  props: {
    position: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      FLOW_POSITION,
    };
  },
  computed: {
    isKyc() {
      return this.position.includes("KYC");
    },
  },
};
</script>

<style scoped lang="scss">
.kyc-prep::v-deep {
  .requirement {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 1rem 0;

    &__icon {
      height: 40px;
      width: 40px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 182, 127, 0.45);
    }
  }
}
</style>
